module Meevo.Model {
  export class SmartTileParameterNames {
    public static salesType: string = 'salesType';
    public static ticketCountType: string = 'ticketCountType';
    public static dateRange: string = 'dateRange';
    public static includedEmployees: string = 'includedEmployees';
    public static locations: string = 'locations';
    public static locationGroup: string = 'locationGroup';
    public static shortcut: string = 'shortcut';
    public static image: string = 'image';
    public static appointmentState: string = 'appointmentState';
    public static numberType: string = 'numberType';
    public static serviceId: string = 'serviceId';
    public static membershipType: string = 'membershipType';
    public static employeeId: string = 'employeeId';
    public static employeeCode: string = 'employeeCode';
    public static serviceCategory: string = 'serviceCategory';
    public static productCategory: string = 'productCategory';
  }
}
